import emailValidator from "foundation/js/inputValidators/emailValidator";
import isBoolean from "foundation/js/inputValidators/isBoolean";
import nameValidator from "foundation/js/inputValidators/nameValidator";
import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";
import phoneValidator from "foundation/js/inputValidators/phoneValidator";
import postalCodeValidator from "foundation/js/inputValidators/postalCodeValidator";

const config = [
    {
        name: 'nameOfEvent',
        value: '',
        isValid: false,
        validator: nameValidator
    },
    {
        name: 'description',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'shareInMainCalendar',
        value: false,
        isValid: true,
        validator: isBoolean
    },
    {
        name: 'mandatoryRegistration',
        value: false,
        isValid: true,
        validator: isBoolean
    },
    {
        name: 'maxParticipants',
        value: 0,
        isValid: true,
        validator: (value) => (value == undefined || (value > 0 && value <= 20000))
    },
    {
        name: 'contactPersonMyself',
        value: false,
        isValid: true,
        validator: isBoolean
    },
    {
        name: 'contactPersonOther',
        value: false,
        isValid: true,
        validator: isBoolean
    },
    {
        name: 'contactPersonEmail',
        value: '',
        isValid: false,
        validator: emailValidator
    },
    {
        name: 'contactPersonName',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'contactPersonPhone',
        value: '',
        isValid: true,
        validator: (phonenumber) => !phonenumber || phoneValidator(phonenumber)
    },
    {
        name: 'startDate',
        value: '',
        isValid: false,
        validator: () => false
    }, 
    {
        name: 'endDate',
        value: '',
        isValid: false,
        validator: () => false
    },
    {
        name: 'startTime',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'endTime',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'address',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'postalCode',
        value: '',
        isValid: false,
        validator: postalCodeValidator
    },
    {
        name: 'city',
        value: '',
        isValid: false,
        validator: nonEmptyStringValidator
    
    }
]

export default config